import { TRAY_OPENED, TRAY_CLOSED } from '../redux/tray';

import type { EventTracking, TrayAction } from '../types';

export const pbr_tray_opened = 'pbr_tray_opened';
export const pbr_tray_closed = 'pbr_tray_closed';

function trayOpened(action: TrayAction) {
  const { vibe_name, comp_name, additionalTrackingProps = {} } = action.payload;

  return {
    vibe_name,
    comp_name,
    ...additionalTrackingProps,
  };
}

function trayClosed(action: TrayAction) {
  const { vibe_name, comp_name, additionalTrackingProps = {} } = action.payload;

  return {
    vibe_name,
    comp_name,
    ...additionalTrackingProps,
  };
}

const tracking: EventTracking = {};
tracking[TRAY_OPENED] = trayOpened;
tracking[TRAY_CLOSED] = trayClosed;

export default tracking;
